module.exports = __webpack_public_path__ + "static/media/scores.20c68950.png";